import { Chip, Stack, Typography } from '@mui/material'

import { PreSale } from '@/clients/utoniq-core/schema'
import { PreSaleStatusTag } from '@/components/organisms'
import { useTranslation } from '@/core'
import { Cell, CellFrame } from '@/core/architecture'

type StatusCellProps = {
  isLottery: boolean
  preSaleStatus: PreSale['preSaleStatus']
  createdAt: PreSale['createdAt']
  isPublished: PreSale['isPublished']
}
export const StatusCell: Cell<StatusCellProps> = ({
  isLottery,
  preSaleStatus,
  createdAt,
  isPublished,
}) => {
  const { t } = useTranslation('consolePreSaleDetail')
  return (
    <CellFrame>
      <Stack direction="row" alignItems="center" spacing={1} sx={{ py: 2 }}>
        <Stack
          direction="row"
          alignItems="center"
          spacing={1}
          sx={{ flex: 1, minWidth: 'fit-content' }}
        >
          <Chip
            variant="outlined"
            label={
              <Typography variant="overline">
                {t(isLottery ? 'lottery' : 'FCFS')}
              </Typography>
            }
            sx={{
              bgcolor: 'background.default',
              p: 0,
              height: 20,
              '.MuiChip-label': { p: 1 },
            }}
          />
          <Chip
            size="small"
            label={
              <Typography variant="overline" color="white">
                {t(isPublished ? 'published' : 'unpublished')}
              </Typography>
            }
            color={isPublished ? 'primary' : 'default'}
            sx={{
              height: 20,
              '.MuiChip-label': { p: 1 },
            }}
          />
          <PreSaleStatusTag status={preSaleStatus} />
          <Typography variant="caption" color="text.secondary">
            {t('publishAt', { createdAt })}
          </Typography>
        </Stack>
      </Stack>
    </CellFrame>
  )
}
